
fx.ns("shared.stage", class FrameArea extends shared.stage.Area {
    
	constructor(page, model, parentContainer, preview)
	{
        super(page, model, parentContainer, "", preview);

        this.listenUpdates(this.creation, true);
   }
  
    /***************** Actions *****************/

    get frame()
    {
    return this.element;
    }

    get single()
    {
    return true;
    }

   

  /***************** Overrides *****************/


    create()
    {
        super.create();

        // add border wood / white / black

       
        this.frameBorder = new fx.components.Image(this.creation.borderAsset);

        this.stageContainer.addChild(this.frameBorder, this.borderViewport);
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);
        
        if (action.model == this.creation && action.type == "update" && action.impacts("formatid"))
        {
            this.frameBorder.data = this.creation.borderAsset;
            this.frameBorder.viewport(this.borderViewport);
        }
            
    }

    get borderViewport()
    {
        return {
                    top : -this.creation.borderSize, 
                    left :-this.creation.borderSize, 
                    height : this.height() + (2*this.creation.borderSize) + 2, 
                    width : this.width() + (2*this.creation.borderSize) + 2
                };
    }
 
});